module.exports = __webpack_public_path__ + "static/media/add-user.698c7fb6.png";